import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";
import { ApiCommonParams } from "../../@types/apiTypes";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

export function listTelawahs(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});

  return Axios.get("v1/telawahs", { params: params });
}
